const ALL_REAL_ESTATES_FROM_OMA_RECEIVED = 'ALL_REAL_ESTATES_FROM_OMA_RECEIVED';
const UPDATE_PRICE_TREND = 'MY_PROPERTY.UPDATE_PRICE_TREND';
const SET_SELECTED_REAL_ESTATE = 'SET_SELECTED_REAL_ESTATE';
const SET_DID_COMPLETE_SURVEY = 'SET_DID_COMPLETE_SURVEY';
const UPDATE_DESIRED_PRICE = 'UPDATE_DESIRED_PRICE';
const REFRESH_ALL_REAL_ESTATES = 'REFRESH_ALL_REAL_ESTATES';

const allRealEstatesFromOmaReceived = (allRealEstates) => ({
  type: ALL_REAL_ESTATES_FROM_OMA_RECEIVED,
  allRealEstates,
});

const createUpdatePriceTrend = (priceTrend) => ({
  type: UPDATE_PRICE_TREND,
  priceTrend,
});

const setSelectedRealEstate = (realEstate) => ({
  type: SET_SELECTED_REAL_ESTATE,
  realEstate,
});

const updateDesiredPrice = (desiredPrice) => ({
  type: UPDATE_DESIRED_PRICE,
  desiredPrice,
});

const setDidCompleteSurvey = () => ({
  type: SET_DID_COMPLETE_SURVEY,
});

const refreshAllRealEstates = (allRealEstates) => ({
  type: REFRESH_ALL_REAL_ESTATES,
  allRealEstates,
});

export {
  UPDATE_PRICE_TREND,
  ALL_REAL_ESTATES_FROM_OMA_RECEIVED,
  SET_SELECTED_REAL_ESTATE,
  SET_DID_COMPLETE_SURVEY,
  UPDATE_DESIRED_PRICE,
  REFRESH_ALL_REAL_ESTATES,
  createUpdatePriceTrend,
  allRealEstatesFromOmaReceived,
  setSelectedRealEstate,
  setDidCompleteSurvey,
  updateDesiredPrice,
  refreshAllRealEstates,
};
